const loader = (data) => {
  const retVal = {
    columns: {
      bq: {},
      finding: {},
      bq_summary: {},
    },
    api: {
      report: {},
      account: {},
      bq: {},
    },
    license: {},
    summaryRules: [],
    schema: {},
    enum: {
      user: {},
      finding: {},
    },
  };

  retVal["columns"]["bq"] = data["bq"].columns;
  retVal["columns"]["bq_summary"] = data["bq_summary"].columns;
  retVal["columns"]["finding"] = data["finding"].columns;

  retVal["api"]["report"] = data["report"];
  retVal["api"]["account"] = data.account;
  retVal["api"]["bq"] = data.models.bq;

  retVal["license"] = data.license;

  retVal["summaryRules"] = data.colossus.summary_rules;

  retVal["enum"]["user"] = data.models.user;
  retVal["enum"]["finding"] = data.models.finding;

  return retVal;
};

export default loader;
